import React from 'react';

interface IconTrashEmptyProps {
    iconClasses?: string;
}

const IconTrashEmpty: React.FC<IconTrashEmptyProps> = ({ iconClasses }) => {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-trash-empty ${iconClasses ?? ''}`}
            stroke="currentColor"
            strokeWidth="1.08333"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M1.625 3.25H11.375" />
            <path d="M10.2923 3.25L9.75065 10.8333C9.75065 11.1207 9.63651 11.3962 9.43335 11.5994C9.23019 11.8025 8.95464 11.9167 8.66732 11.9167H4.33398C4.04667 11.9167 3.77112 11.8025 3.56795 11.5994C3.36479 11.3962 3.25065 11.1207 3.25065 10.8333L2.70898 3.25" />
        </svg>
    );
};

export default IconTrashEmpty;
